import { useParams } from "react-router-dom";
export default useParams;
